<template>

  <b-overlay :show="loading">

    <b-form-group label="Merk" label-class="font-weight-bold">
      <b-select :options="brands.nodes" v-model="brand.connectById.id "/>
    </b-form-group>

    <b-form-group label="Naam" label-class="font-weight-bold">
      <b-input v-model="name"/>
    </b-form-group>

    <b-form-group label="SNMP naam" label-class="font-weight-bold">
      <b-input v-model="snmpName"/>
    </b-form-group>

    <b-form-group label="Profiel" label-class="font-weight-bold">
      <b-select :options="profiles.nodes" text-field="name" value-field="id" v-model="profileId">
        <b-form-select-option :value="null">*** Geen profiel ***</b-form-select-option>
      </b-select>
    </b-form-group>

    <b-form-group label="Markeringen">
      <b-form-checkbox v-model="detectOk" inline>Detectie OK</b-form-checkbox>
      <b-form-checkbox v-model="profileOk" inline>Profiel OK</b-form-checkbox>
    </b-form-group>

  </b-overlay>

</template>

<script>

import {CACHE_AND_NETWORK, NETWORK_ONLY} from '@/lib/constants';

export default
{
    apollo:
    {
        brands:
        {
            query: require('../graphql/query/brands_dropdown.gql')
        },
        profiles:
        {
            query: require('../graphql/list_profiles.gql'),
            fetchPolicy: CACHE_AND_NETWORK
        }
    },
    data()
    {
        return {
            brands: { nodes: [] },
            detectOk: null,
            profiles: { nodes: [] },
            // Input fields
            brand: { connectById: { id: null } },
            name: '',
            profileId: '',
            profileOk: null,
            snmpName: '',
            loading: true
        }
    },

    methods:
    {
        async create(ok)
        {
            const profile = this.profileId ? { connectById: { id: this.profileId } } : undefined;

            const variables = {
                model:
                {
                    profile,
                    name: this.name,
                    brand: this.brand,
                    snmpName: this.snmpName
                }
            };

            await this.$apollo.mutate(
                {
                    mutation: require('../graphql/createModel.gql'),
                    variables
                }
            );

            await ok();
        },
        async saveEdit(ok)
        {
            const profile = this.profileId ? { connectById: { id: this.profileId } } : undefined;
            const profileId = this.profileId === null ? null : undefined;

            const variables = {
                input:
                {
                    id: this.id,
                    patch:
                    {
                        detectOk: this.detectOk,
                        profile,
                        profileId,
                        name: this.name,
                        brand: this.brand,
                        profileOk: this.profileOk,
                        snmpName: this.snmpName
                    }
                }
            };

            await this.$apollo.mutate(
                {
                    mutation: require('../graphql/updateModel.gql'),
                    variables
                }
            );

            await ok();
        },
    },
    async mounted()
    {
        if(this.id)
        {
            const {data: { model }} = await this.$apollo.query(
                {
                    query: require('../graphql/for_edit_model.gql'),
                    variables: { id: this.id },
                    fetchPolicy: NETWORK_ONLY
                }
            );

            this.profileId            = model.profile?.id || null;
            this.name                 = model.name;
            this.snmpName             = model.snmpName;
            this.brand.connectById.id = model.brand.id;
            this.detectOk             = model.detectOk;
            this.profileOk            = model.profileOk;
        }

        this.loading = false;
    },
    props:
    {
        id: { }
    }
}
</script>

<style>
</style>